import React from "react";
import { useNavigate } from "react-router-dom";
import { getTokenUseCase } from "@/features/auth/use-cases";

import serviceBg01 from "@/shared/assets/img/service-bg01.png";
import serviceBg02 from "@/shared/assets/img/service-bg02.png";
import serviceBg03 from "@/shared/assets/img/service-bg03.png";
import serviceBg04 from "@/shared/assets/img/service-bg04.png";

import serviceBg01M from "@/shared/assets/img/service-bg01-m.png";
import serviceBg02M from "@/shared/assets/img/service-bg02-m.png";
import serviceBg03M from "@/shared/assets/img/service-bg03-m.png";
import serviceBg04M from "@/shared/assets/img/service-bg04-m.png";

/**
 * ServiceContent - Service page content component
 * 서비스 페이지의 모든 섹션 포함
 */
export const ServiceContent: React.FC = () => {
  const navigate = useNavigate();
  const isLoggedIn = getTokenUseCase.hasToken();
  return (
    <main className="flex-1">
      {/* Service Section 1 */}
      <section className="w-full">
        <img
          src={serviceBg01}
          alt="Service 1"
          className="hidden md:block w-full h-auto"
        />
        <img
          src={serviceBg01M}
          alt="Service 1 Mobile"
          className="md:hidden w-full h-auto"
        />
      </section>

      {/* Service Section 2 */}
      <section className="w-full">
        <img
          src={serviceBg02}
          alt="Service 2"
          className="hidden md:block w-full h-auto"
        />
        <img
          src={serviceBg02M}
          alt="Service 2 Mobile"
          className="md:hidden w-full h-auto"
        />
      </section>

      {/* Service Section 3 */}
      <section className="w-full">
        <img
          src={serviceBg03}
          alt="Service 3"
          className="hidden md:block w-full h-auto"
        />
        <img
          src={serviceBg03M}
          alt="Service 3 Mobile"
          className="md:hidden w-full h-auto"
        />
      </section>

      {/* Service Section 4 */}
      <section className="w-full">
        <img
          src={serviceBg04}
          alt="Service 4"
          className="hidden md:block w-full h-auto"
        />
        <img
          src={serviceBg04M}
          alt="Service 4 Mobile"
          className="md:hidden w-full h-auto"
        />
      </section>

      {/* CTA Section */}
      <section className="w-full bg-orange-50 py-12 md:py-20">
        <div className="max-w-2xl mx-auto px-4 flex flex-col items-center justify-center gap-6 md:gap-7">
          <div className="text-center space-y-2">
            <p className="text-base md:text-xl text-black font-normal font-['NanumSquareRound'] leading-relaxed md:leading-8">
              발달 전문가와 AI가 함께 설계한{" "}
              <span className="text-orange-500 font-extrabold">
                13,000개 이상
              </span>
              의
              <br />
              단계별 디지털 학습 콘텐츠로{" "}
              <span className="font-extrabold">
                아이의 하루를 성장으로 채워요
              </span>
            </p>
          </div>
          {!isLoggedIn && (
            <button
              onClick={() => navigate("/free-trial")}
              className="px-6 md:px-8 py-2 md:py-3 bg-orange-500 rounded-full text-white text-base md:text-lg font-bold font-['NanumSquareRoundOTF'] hover:bg-orange-600 transition-colors whitespace-nowrap"
            >
              무료체험 신청하기
            </button>
          )}
        </div>
      </section>
    </main>
  );
};
